import React, { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { parseLocaleDatetime } from "../../../common/util";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import RadioListTable from "../../base/table/RadioListTable";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { CustomCircleCheckBox, CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as CheckRequestImg } from '../../../img/btn-radio-incon-check-inactive.svg';
import { ReactComponent as CheckImg } from '../../../img/btn-radio-incon-check-active.svg';

import { useTranslation } from "react-i18next";
import { AccountUuidParse } from "../../../interfaceTypes/AccountType";
import { VmBackupData } from "./BackupData";
import { guestOsDropdownItem } from "components/virtLogicalResource/image/VmImageData";
import CustomText from "components/base/CustomText";

interface BackupRestoreProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: VmBackupData,
}

BackupRestore.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function BackupRestore(props:BackupRestoreProps) {
    const { t } = useTranslation();
    const [stepIndex, setStepIndex] = useState(0);
    const [executeRestoreImageYn, setExecuteRestoreImageYn] = useState(false);

    const [vmImageName, setVmImageName] = useState("");
    const [vmImageDesc, setVmImageDesc] = useState("");
    const [vmImagePubType, setVmImagePubType] = useState("PUB");
    const [guestOs, setGuestOs] = useState(props.args?.os_type_code?props.args?.os_type_code : guestOsDropdownItem[0].value);
    const [useClusterYn, setUseClusterYn] = useState(false);
    const [vmImageNameWarnYn, setVmImageNameWarnYn] = useState(false);
    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            const successYn = checkVmImageData();
                if(successYn) {
                    setExecuteRestoreImageYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeRestoreImageYn) {
            executeRestoreVmImage();
        }
    }, [executeRestoreImageYn]);
    

    function checkVmImageData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setVmImageNameWarnYn(false);


        let message = "";
        let error = false;
        if(!vmImageName) {
            message = t("MESSAGE_VM_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            setVmImageNameWarnYn(true);
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteRestoreImageYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeRestoreVmImage() {

        const addVmImageData = {
            vm_image : {
                vm_image_name: vmImageName,
                vm_image_description: vmImageDesc,
                share_type_code: vmImagePubType,
                os_type_code: guestOs,
                container_vm_image_yn: useClusterYn
            }
        };
        
        requests.post(PLATFORM_URL.VM_BACKUP + '/' + props.args?.vm_backup_id + '/restore', addVmImageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    function selectButton(id, type){
        setVmImagePubType(type);
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("BACKUP_IMAGE_RESTORE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("VM_BACKUP_IMAGE_NAME")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.vm_backup_name}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("VM_BACKUP_IMAGE_FILE_NAME")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.vm_backup_filename}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={{...style.columeData, overflow: "hidden"}} numberOfLines={1}>
                                {props.args?.vm_backup_description}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("IMAGE_STATUS_TEXT")}
                            </Text>
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                {
                                    props.args?.vm_backup_status_code === "AVB" ? <ActiveImg />
                                    : props.args?.vm_backup_status_code === "CRT" ? <IdleImg />
                                    : props.args?.vm_backup_status_code === "IMP" ? <AlertImg />
                                    : <ErrorImg />
                                }
                                <Text style={{
                                    ...style.columeData, width: 100,
                                    color: props.args?.vm_backup_status_code === "AVB" ? "#3a8344"
                                            : props.args?.vm_backup_status_code === "CRT" ? "#0853fb"
                                            : props.args?.vm_backup_status_code === "IMP" ? "#7066f1"
                                            : "#e86045"
                                }}>
                                    {
                                        props.args?.vm_backup_status_code === "AVB" ? t("AVAIL_TEXT")
                                        : props.args?.vm_backup_status_code === 'CRT' ? t("CREATING_TEXT")
                                        : props.args?.vm_backup_status_code === 'IMP' ? t("DOWNLOADING_TEXT")
                                        : t("UNAVAIL_TEXT")
                                    }
                                </Text>
                            </View>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("PROJECT_NAME_TEXT")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.project?.project_name}
                            </Text>
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={{...style.titleText, marginTop: 10}}>{
                        t("RESTORE_IMAGE_FILE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VN_IMAGE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={vmImageName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageName}
                                warnYn={vmImageNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={100}
                                value={vmImageDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GUEST_OS_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={guestOsDropdownItem}
                                setValue={setGuestOs}
                                disable={false}
                                defaultvalue={{value: "NONE", label: t("EMPTY_TEXT")}}
                            />
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                            <Text style={style.columnText}>
                                    {t("VM_IMAGE_ADD_USE_CLUSTER_TYPE_TEXT")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={107}
                                    label={t("VM_IMAGE_ADD_USE_CLUSTER_TYPE_TEXT")} 
                                    id={"ResourceCheckbox"} 
                                    checked={useClusterYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={()=>{setUseClusterYn(!useClusterYn)}}
                                />
                            </View>
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={{...style.titleText, marginTop: 10}}>{
                        t("SHARE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SHARE_CATEGORY_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PUB"}
                                size={18}
                                checked={vmImagePubType === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PRJ"}
                                size={18}
                                checked={vmImagePubType === "PRJ" ? true: false}
                                selectCb={selectButton}
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                        </View>
                    </View>
                </View>
                :null 
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    columeData: {
        width: 550,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
        overflow: "scroll"
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    }
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}
